import { useRef } from 'react';
import {
	Devices,
	OnOff,
	useComponentAnimation,
	useShowComponent,
} from '../VirtualArticle.hooks';

export const VirtualDivider = (props: DividerProps) => {
	const { bleed, expandFullWidth, id, devices, animation } = props;
	const ref = useRef(null);
	const animationClasses = useComponentAnimation({
		ref,
		animation,
	});
	const deviceClassNames = useShowComponent(devices);

	if (id === 'Cf2-738193852') {
		console.log(`Divider`, animationClasses);
	}

	const containerStyle: any = {
		clear: 'both',
	};
	const componentStyle: any = {};

	if (expandFullWidth) {
		componentStyle.minWidth = '100%';
		componentStyle.width = '100%';
	}

	const classNames = ['divider', ...animationClasses];
	if (props.style) {
		classNames.push(props.style);
		classNames.push(`style-${props.style}`);
	}
	if (bleed === 'on') {
		classNames.push('bleed');
	}

	classNames.push(deviceClassNames);

	return (
		<div
			id={id}
			ref={ref}
			style={containerStyle}
			className={classNames.join(' ')}
		>
			<hr style={componentStyle} />
		</div>
	);
};

interface DividerProps {
	id: string;
	bleed: OnOff;
	expandFullWidth: boolean;
	devices: Devices;
	style?: string;
	animation: any;
}
